import type { ContactResult, EntityResult, UserResult } from '@/lib/search';

export const MIN_QUERY_LENGTH = 2;

export const SEARCH_TYPES: ('ahoy_user' | 'ahoy_contact')[] = [
  'ahoy_user',
  'ahoy_contact',
];

export const isValidEmail = (email: string): boolean => {
  const trimmed = email.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
};

export const parseEmails = (text: string): string[] =>
  text
    .split(/[,;\s\n]+/)
    .map(e => e.trim())
    .filter(e => e.length > 0);

export function hasEmail(
  entity: EntityResult
): entity is UserResult | ContactResult {
  return entity.type === 'ahoy_user' || entity.type === 'ahoy_contact';
}
